export const List = () => import("./List.vue");
export const BulkSale = () => import("./BulkSale.vue");
export const Create = () => import("./Create.vue");
export const OtherCreate = () => import("./OtherCreate.vue");
export const PurchaseReturn = () => import("./PurchaseReturn.vue");
export const Edit = () => import("./Edit.vue");
export const View = () => import("./View.vue");
